module.exports = __webpack_public_path__ + "fonts/shadows-into-light-v6-latin-regular.eot";


//////////////////
// WEBPACK FOOTER
// ./web/fonts/shadows-into-light-v6-latin-regular.eot
// module id = 283
// module chunks = 0